document.addEventListener('DOMContentLoaded', function () {

  // ── GLASS TYPE REFERENCE TOGGLE ──────────────────────────
  const refToggle = document.getElementById('glass-ref-toggle');
  const refBody   = document.getElementById('glass-ref-body');
  const refArrow  = document.getElementById('glass-ref-arrow');
  if (refToggle) {
    refToggle.addEventListener('click', function () {
      const isOpen = refBody.classList.contains('open');
      refBody.classList.toggle('open', !isOpen);
      refArrow.classList.toggle('open', !isOpen);
    });
  }

  // ── EDGE FINISH RATES (inc-GST per linear metre) ────────
  // Perimeter (lm) = 2 × (width_mm + height_mm) ÷ 1000
  const calculatorRoot = document.getElementById('glass-calculator');
  function readDataRate(name, fallback) {
    if (!calculatorRoot) return fallback;
    const raw = calculatorRoot.dataset[name];
    const parsed = parseFloat(raw);
    return isNaN(parsed) ? fallback : parsed;
  }

  const finishData = {
    'hand-seamed':   { label: 'Hand Seamed',   rateInc: readDataRate('edgeHandSeamed', 3.00) },
    'flat-polished': { label: 'Flat Polished', rateInc: readDataRate('edgeFlatPolished', 7.00) },
    'beveled':       { label: 'Beveled',       rateInc: readDataRate('edgeBeveled', 28.00) }
  };

  // ── CALCULATOR DATA ──────────────────────────────────────
  // All prices are inc. GST per m².
  // finishes[] controls which edge options appear for that grade.
  // If a grade has no finishes key, defaults are applied in buildFinish().
  const glassData = {
    'clear': {
      grades: {
        'annealed':  {
          note: 'Clear float glass. Price per m² inc. GST.',
          thicknesses: { '4mm':43.44,'5mm':47.78,'6mm':52.14,'8mm':92.14,'10mm':120.66,'12mm':142.62,'15mm':423.96,'19mm':552.42 },
          finishes: ['hand-seamed','flat-polished','beveled']
        },
        'toughened': {
          note: 'Toughened clear safety glass. Price per m² inc. GST.',
          thicknesses: { '4mm':64.04,'5mm':68.58,'6mm':73.16,'8mm':118.98,'10mm':148.76,'12mm':177.84,'15mm':578.14,'19mm':899.30 },
          finishes: ['flat-polished','beveled']
        },
        'laminated': {
          note: 'Laminated clear safety glass. Price per m² inc. GST.',
          thicknesses: { '6.38mm':83.86,'8.38mm':113.32,'10.38mm':142.24,'12.38mm':190.52 },
          finishes: ['flat-polished','beveled']
        }
      }
    },
    'grey': {
      grades: {
        'annealed':  { note: 'Grey tinted float glass. Price per m² inc. GST.',       thicknesses: { '4mm':59.46,'5mm':75.46,'6mm':82.56,'8mm':117.76,'10mm':136.00,'12mm':175.50 } },
        'toughened': { note: 'Toughened grey tinted glass. Price per m² inc. GST.',   thicknesses: { '4mm':86.88,'5mm':88.38,'6mm':105.38,'8mm':157.06,'10mm':180.58,'12mm':212.46 } },
        'laminated': { note: 'Laminated grey tinted glass. Price per m² inc. GST.',   thicknesses: { '6.38mm':105.34,'10.38mm':155.18,'12.38mm':305.08 } }
      }
    },
    'super-grey': {
      grades: {
        'annealed':  { note: 'Super grey tinted float glass. Price per m² inc. GST.',     thicknesses: { '6mm':200.62 } },
        'toughened': { note: 'Toughened super grey tinted glass. Price per m² inc. GST.', thicknesses: { '6mm':220.46 } }
      }
    },
    'bronze': {
      grades: {
        'annealed':  { note: 'Bronze tinted float glass. Price per m² inc. GST.',     thicknesses: { '6mm':134.66 } },
        'toughened': { note: 'Toughened bronze tinted glass. Price per m² inc. GST.', thicknesses: { '6mm':228.64 } }
      }
    },
    'green': {
      grades: {
        'annealed':  { note: 'Green tinted float glass. Price per m² inc. GST.',     thicknesses: { '6mm':160.40 } },
        'toughened': { note: 'Toughened green tinted glass. Price per m² inc. GST.', thicknesses: { '6mm':229.18 } }
      }
    },
    'low-iron': {
      grades: {
        'annealed':  { note: 'Low iron (ultra clear) float glass. Price per m² inc. GST.', thicknesses: { '4mm':105.18,'5mm':98.30,'6mm':101.62,'8mm':173.20,'10mm':187.34,'12mm':200.64 } },
        'toughened': { note: 'Toughened low iron glass. Price per m² inc. GST.',           thicknesses: { '4mm':144.04,'5mm':132.10,'6mm':132.62,'8mm':228.62,'10mm':237.86,'12mm':254.04 } }
      }
    },
    'matelux': {
      grades: {
        'annealed':  { note: 'Matelux acid etched frosted glass. Price per m² inc. GST.',  thicknesses: { '4mm':91.26,'5mm':100.06,'6mm':108.60,'10mm':182.90,'12mm':191.66 } },
        'toughened': { note: 'Toughened Matelux acid etched glass. Price per m² inc. GST.',thicknesses: { '4mm':106.70,'5mm':115.52,'6mm':124.10,'10mm':228.62,'12mm':237.86 } }
      }
    },
    'spotswood': {
      grades: {
        'annealed':  { note: 'Spotswood patterned glass. Price per m² inc. GST.',          thicknesses: { '4mm':101.10,'5mm':116.98,'6mm':86.88 } },
        'toughened': { note: 'Toughened Spotswood patterned glass. Price per m² inc. GST.',thicknesses: { '4mm':137.16,'5mm':143.04,'6mm':109.30 } }
      }
    },
    'cathedral': {
      grades: {
        'annealed':  { note: 'Cathedral patterned glass. Price per m² inc. GST.',          thicknesses: { '4mm':76.92 } },
        'toughened': { note: 'Toughened Cathedral patterned glass. Price per m² inc. GST.',thicknesses: { '4mm':95.24 } }
      }
    },
    'satinlite': {
      grades: {
        'annealed':  { note: 'Satinlite patterned glass. Price per m² inc. GST.',          thicknesses: { '4mm':99.06,'5mm':116.98,'6mm':127.20 } },
        'toughened': { note: 'Toughened Satinlite patterned glass. Price per m² inc. GST.',thicknesses: { '4mm':137.16,'5mm':143.04,'6mm':177.84 } }
      }
    },
    'narrowline': {
      grades: {
        'annealed':  { note: 'Narrowline reeded glass. Price per m² inc. GST.',            thicknesses: { '6mm':152.40,'10mm':254.04 } },
        'toughened': { note: 'Toughened Narrowline reeded glass. Price per m² inc. GST.',  thicknesses: { '6mm':165.12,'10mm':342.94 } }
      }
    },
    'ultra-clear-narrowline': {
      grades: {
        'annealed':  { note: 'Ultra clear Narrowline reeded glass. Price per m² inc. GST.',     thicknesses: { '5mm':203.22 } },
        'toughened': { note: 'Toughened ultra clear Narrowline reeded glass. Price per m² inc. GST.', thicknesses: { '5mm':248.40 } }
      }
    }
  };
  const MIN_CHARGE = readDataRate('minimumCharge', 30);

  let selType   = 'clear';
  let selGrade  = 'annealed';
  let selThick  = '';
  let selFinish = 'hand-seamed';

  const typeSelector   = document.getElementById('glass-type-selector');
  const gradeSelector  = document.getElementById('glass-grade-selector');
  const thickSelector  = document.getElementById('thickness-selector');
  const finishSelector = document.getElementById('finish-selector');
  const finishNote     = document.getElementById('finish-note');
  const thickNote      = document.getElementById('thickness-note');
  const gradeNote      = document.getElementById('grade-note');
  const priceEl        = document.getElementById('calc-price');
  const widthEl        = document.getElementById('calc-width');
  const heightEl       = document.getElementById('calc-height');

  function buildGrades(type) {
    const availableGrades = Object.keys(glassData[type].grades);
    gradeSelector.querySelectorAll('.glass-chip').forEach(function(btn) {
      const g = btn.dataset.grade;
      if (availableGrades.includes(g)) {
        btn.disabled = false;
        btn.style.opacity = '1';
        btn.style.cursor = 'pointer';
      } else {
        btn.disabled = true;
        btn.classList.remove('selected');
        btn.style.opacity = '0.35';
        btn.style.cursor = 'not-allowed';
      }
    });
    if (!availableGrades.includes(selGrade)) { selGrade = availableGrades[0]; }
    gradeSelector.querySelectorAll('.glass-chip').forEach(function(btn) {
      btn.classList.toggle('selected', btn.dataset.grade === selGrade);
    });
    buildThickness(type, selGrade);
  }

  function buildFinish(type, grade) {
    if (!finishSelector) return;
    finishSelector.innerHTML = '';
    const gradeObj  = glassData[type] && glassData[type].grades[grade];
    const defaultFinishes = (grade === 'annealed') ? ['hand-seamed','flat-polished','beveled'] : ['flat-polished','beveled'];
    const available = (gradeObj && gradeObj.finishes) ? gradeObj.finishes : defaultFinishes;
    if (!available.includes(selFinish)) { selFinish = available[0]; }
    available.forEach(function(f) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'glass-chip' + (f === selFinish ? ' selected' : '');
      btn.dataset.finish = f;
      btn.textContent = finishData[f].label;
      finishSelector.appendChild(btn);
    });
    if (finishNote) finishNote.textContent = 'Edge finish cost is included in the total estimate above.';
  }

  function buildThickness(type, grade) {
    thickSelector.innerHTML = '';
    const gradeObj = glassData[type].grades[grade];
    if (!gradeObj) { thickNote.textContent = ''; gradeNote.textContent = ''; return; }
    gradeNote.textContent = gradeObj.note || '';
    if (!gradeObj.thicknesses) {
      thickNote.textContent = 'This combination requires a custom quote — please use the form below.';
      priceEl.style.fontSize = '1.5rem';
      priceEl.textContent = 'Email for Quote';
      buildFinish(type, grade);
      return;
    }
    priceEl.style.fontSize = '';
    thickNote.textContent = '';
    const keys = Object.keys(gradeObj.thicknesses);
    selThick = keys[0];
    keys.forEach(function(k, i) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'thick-btn' + (i === 0 ? ' selected' : '');
      btn.textContent = k;
      btn.dataset.key = k;
      btn.addEventListener('click', function () {
        thickSelector.querySelectorAll('.thick-btn').forEach(function(b) { b.classList.remove('selected'); });
        this.classList.add('selected');
        selThick = this.dataset.key;
        calculate();
      });
      thickSelector.appendChild(btn);
    });
    buildFinish(type, grade);
    calculate();
  }

  function calculate() {
    const gradeObj = glassData[selType].grades[selGrade];
    if (!gradeObj || !gradeObj.thicknesses) { return; }
    const wMM = parseFloat(widthEl.value);
    const hMM = parseFloat(heightEl.value);
    const w = wMM / 1000;
    const h = hMM / 1000;
    if (!w || !h || w <= 0 || h <= 0) { priceEl.textContent = '$0.00'; return; }
    const area    = w * h;
    const rateInc = gradeObj.thicknesses[selThick];
    if (!rateInc) { priceEl.textContent = 'POA'; return; }

    // Glass cost (all prices already inc. GST) — no floor here
    const glassCostInc = area * rateInc;

    // Edge finish cost: perimeter (lm) × rate inc. GST
    const perimLM     = 2 * (wMM + hMM) / 1000;
    const fData       = finishData[selFinish];
    const edgeCostInc = fData ? (perimLM * fData.rateInc) : 0;

    // Strict per-panel minimum: the COMBINED glass + edge price is floored at
    // MIN_CHARGE. The calculated price only applies once it exceeds the minimum.
    const totalInc = Math.max(glassCostInc + edgeCostInc, MIN_CHARGE);

    priceEl.style.fontSize = '';
    priceEl.textContent = '$' + totalInc.toFixed(2);
  }

  // Type chip clicks
  typeSelector.addEventListener('click', function (e) {
    const chip = e.target.closest('.glass-chip');
    if (!chip) return;
    typeSelector.querySelectorAll('.glass-chip').forEach(function(c) { c.classList.remove('selected'); });
    chip.classList.add('selected');
    selType = chip.dataset.type;
    buildGrades(selType);
  });

  // Grade chip clicks
  gradeSelector.addEventListener('click', function (e) {
    const chip = e.target.closest('.glass-chip');
    if (!chip || chip.disabled) return;
    gradeSelector.querySelectorAll('.glass-chip').forEach(function(c) { c.classList.remove('selected'); });
    chip.classList.add('selected');
    selGrade = chip.dataset.grade;
    buildThickness(selType, selGrade);
  });

  // Finish chip clicks
  if (finishSelector) {
    finishSelector.addEventListener('click', function (e) {
      const chip = e.target.closest('.glass-chip');
      if (!chip) return;
      finishSelector.querySelectorAll('.glass-chip').forEach(function(c) { c.classList.remove('selected'); });
      chip.classList.add('selected');
      selFinish = chip.dataset.finish;
      calculate();
    });
  }

  [widthEl, heightEl].forEach(function(el) { el.addEventListener('input', calculate); });
  buildGrades(selType);

  // ── FAQ ──────────────────────────────────────────────────
  const faqWrap = document.getElementById('faq-container');
  if (faqWrap) {
    faqWrap.addEventListener('click', function (e) {
      const btn = e.target.closest('.faq-question');
      if (!btn) return;
      const item   = btn.parentElement;
      const answer = item.querySelector('.faq-answer');
      const arrow  = btn.querySelector('.faq-arrow');
      const isOpen = answer.style.maxHeight && answer.style.maxHeight !== '0px';
      faqWrap.querySelectorAll('.faq-item').forEach(o => {
        o.querySelector('.faq-answer').style.maxHeight = '0px';
        o.querySelector('.faq-answer').style.paddingBottom = '0';
        o.querySelector('.faq-arrow').classList.remove('rotate-180');
      });
      if (!isOpen) {
        answer.style.maxHeight = answer.scrollHeight + 'px';
        answer.style.paddingBottom = '1.25rem';
        arrow.classList.add('rotate-180');
      }
    });
  }

  // ── FLOATING CTA ─────────────────────────────────────────
  const floatBtn = document.getElementById('floating-cta');
  const root     = document.querySelector('.shopify-section--custom-glass');
  const heroH    = root?.querySelector('main section:first-child')?.offsetHeight || 500;
  window.addEventListener('scroll', function () {
    if (window.scrollY > heroH) { floatBtn.classList.add('visible'); }
    else { floatBtn.classList.remove('visible'); }
    // Hide near the quote form to avoid overlap
    const form = document.getElementById('quote-form');
    if (form) {
      const formTop = form.getBoundingClientRect().top;
      if (formTop < window.innerHeight) { floatBtn.classList.remove('visible'); }
    }
  });

});